/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const { setCreditId, setJourneyPrefix } = require('./src/helpers/sessionStorage')
const { injectGTM } = require('./src/helpers/gtm')

const GTM_SIMULADORGA = 'GTM-MM6M3H3J'
const GTM_SIMULADOR3K = 'GTM-56D2LRX3'
const GTM_DEFAULT = process.env.GTM || 'GTM-K5BRQVB'

const isSimuladorGA = (pathname) => pathname && pathname.includes('simuladorGA')
const isSimulador3k = (pathname) => pathname && pathname.includes('simulador3k')

const getGTMContainer = (pathname) => {
  if (isSimuladorGA(pathname)) return GTM_SIMULADORGA
  if (isSimulador3k(pathname)) return GTM_SIMULADOR3K
  return GTM_DEFAULT
}

// Runs once on page load — window.location.pathname is always the real current path here.
// SSR pathname is unreliable in Gatsby v3 with --prefix-paths, so GTM is handled exclusively here.
exports.onClientEntry = () => {
  const pathname = window.location.pathname
  injectGTM(getGTMContainer(pathname))
}

exports.onPreRouteUpdate = ({ location, prevLocation }) => {
  setCreditId()
  setJourneyPrefix()

  if (!prevLocation) return

  // Crossing a GTM container boundary requires a full reload so onClientEntry re-runs
  // with the new pathname and injects the correct GTM container.
  // GTM scripts cannot be unloaded once in memory — a reload is the only clean solution.
  if (getGTMContainer(prevLocation.pathname) !== getGTMContainer(location.pathname)) {
    window.location.href = location.pathname + location.search + location.hash
  }
}
